import { ChipsContainer } from 'app/ComponentLibrary/Filter/ChipsContainer';
import React, { createRef, useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import _, { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Collapse, Grid } from '@mui/material';
import { SearchPageIcons } from 'app/ComponentLibrary/Filter/SearchPageIcons';
import { makeStyles } from 'tss-react/mui';
import { selectFilters } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { PlacementSearchFilterName } from '@AMIEWEB/GlobalSearch/Placement/SearchUtils';
import { calculateParentPath, findBottomNode, injectItem } from '@AMIEWEB/Common/TreeView/TreeViewHelpers';
import { determineChipSelected, generateFieldChips } from '@AMIEWEB/AmWorkDesk/PlacementsDesk/filterHelper';
import { generateChips } from '@AMIEWEB/GlobalSearch/helper';

const useStyles = makeStyles()({
  fillterCollapse: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export const OrderPlacementChips = props => {
  const { classes } = useStyles();
  const { category, collapsable = true } = props;
  const [chips, setChips] = useState({});
  const [showChipsCollapseBtn, setShowChipsCollapseBtn] = useState(false);
  const hiddenSubmitButton = createRef<HTMLButtonElement>();
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();
  const filterObject = useSelector(selectFilters);
  const [checked, setChecked] = React.useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  const handleChange = () => {
    setChecked(prev => !prev);
  };

  const getNewSelection = (key, chip) => ({
    ...filterObject?.selectedChipFilters,
    [key]: determineChipSelected(
      chip,
      filterObject?.selectedChipFilters ? filterObject?.selectedChipFilters[key] : undefined,
    ),
  });

  const handleChipDelete = (key, chip) => {
    const fieldValues = getValues(key) ?? getValues(chip.value);
    let newFieldValues: any = null;
    if (key === PlacementSearchFilterName.status) {
      newFieldValues = injectItem(
        _.cloneDeep(fieldValues),
        calculateParentPath(chip.value),
        findBottomNode(chip.value),
        true,
        'value',
        'name',
      );
    } else if (fieldValues && fieldValues.type && fieldValues.type === 'NestedFilter') {
      const data = generateFieldChips(fieldValues);
      const index = data.findIndex(x => x.label === chip.label);
      newFieldValues = {
        ...fieldValues,
        value: fieldValues.value.filter((item, id) => index !== id),
      };
    } else {
      if (
        fieldValues &&
        Object.hasOwn(fieldValues, 'level') &&
        Object.hasOwn(fieldValues, 'value') &&
        fieldValues?.isLevelSelected === false
      ) {
        let field = cloneDeep(fieldValues);
        field = {
          ...fieldValues,
          value: fieldValues?.value?.filter(item => item !== chip?.value),
        };
        newFieldValues = field;
      } else
      /**Check to avoid click on deletion of valued fields/chips */
        newFieldValues = Array.isArray(fieldValues)
          ? fieldValues.filter(item => item.value !== chip.value.value ?? chip?.value)
          : null;
    }
    setValue(key, newFieldValues, { shouldDirty: true });
    if (chip.isSelected || props.disableFormSubmit) {
      const newSelections = getNewSelection(key, chip);
      props.onApplyFilter(
        {
          ...getValues(),
          [key]: Array.isArray(fieldValues)
            ? [...(newFieldValues || [])]
            : fieldValues.type && fieldValues.type === 'NestedFilter'
            ? newFieldValues
            : null,
        },
        newSelections,
      );
    } else{
       hiddenSubmitButton.current?.click();
    }
    
    
  };

  /** Restricted to call onApplyfilter directly -
   * observes not to remove existing filter and chips */
  const handleChipClick = (key, chip) => {
    /**Check to avoid click on single valued fields/chips */
    if (!Array.isArray(getValues(key))) return;
    /**
     * Below functionalty are limited to type ISelection
     * Need to be updated for dates and single selection
     */
    // Implement chip click for multiple filters
    const newSelections = getNewSelection(key, chip);
    setChips(generateChips({ ...getValues() }, t, category, false, newSelections));
    props.onApplyFilter(getValues(), newSelections);
  };

  useEffect(() => {
    setChips(
      filterObject?.filters
        ? generateChips(filterObject?.filters, t, category, false, filterObject?.selectedChipFilters)
        : {},
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterObject?.filters]);

  useEffect(() => {
    const chipsData = Object.keys(chips).some(key => {
      const value = chips[key];
      if (Array.isArray(value) && value.length > 0) {
        return true;
      }
      if (typeof value === 'object' && value !== null && Object.keys(value).length > 0) {
        return true;
      }
      return false;
    });
    setShowChipsCollapseBtn(chipsData);
  }, [chips]);

  return (
    <>
      {showChipsCollapseBtn && collapsable ? (
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <Collapse in={checked} collapsedSize={38}>
              <div ref={divRef}>
                <ChipsContainer
                  chips={chips}
                  onDelete={(field, chip, index) => handleChipDelete(field, chip)}
                  onClick={(field, chip, index) => handleChipClick(field, chip)}
                  isCollapse={!checked}
                />
              </div>
              <button ref={hiddenSubmitButton} style={{ display: 'none' }} type="submit" />
            </Collapse>
          </Grid>
          <Grid item xs={1} className={classes.fillterCollapse}>
            {(divRef?.current?.clientHeight ?? 0) > 38 && (
              <SearchPageIcons KeyboardArrowIcon onAdvancedChipsClick={() => handleChange()} checked={checked} />
            )}
          </Grid>
        </Grid>
      ) : (
        <>
          <ChipsContainer
            chips={chips}
            onDelete={(field, chip, index) => handleChipDelete(field, chip)}
            onClick={(field, chip, index) => handleChipClick(field, chip)}
          />
          <button ref={hiddenSubmitButton} style={{ display: 'none' }} type="submit" />
        </>
      )}
    </>
  );
};
